import styled from 'styled-components'
import Slider from 'react-slick'

import { Flex } from 'grid-styled'
import theme from '../../../../theme'

export const StyledSlider = styled(Slider)`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const LeftArrow = styled(Flex)`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0px;
  z-index: 1;
  align-items: center;
  font-size: 48px;
  color: grey;
  &:hover {
    color: ${theme.colors.black};
  }
`

export const RightArrow = styled(Flex)`
  position: absolute;
  height: 100%;
  top: 0;
  right: 0px;
  z-index: 1;
  align-items: center;
  font-size: 48px;
  color: grey;
  &:hover {
    color: ${theme.colors.black};
  }
`



// WEBPACK FOOTER //
// ./src/containers/CS/components/ProjectsCarousel/styles.js